import React, { useState } from 'react'
import './Skills.scss'
// import Button from '@cred/neopop-web/lib/components/Button';
import { Button } from "@cred/neopop-web/lib/components";
import resume from '../../assets/resume/Gwira Paradzai Resume.pdf'

import skills from '../../data/skillsExperience'

const Skills = () => {
  const { skill, experience } = skills
  const [isOver, setIsOver] = useState(false);

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = resume;
    link.download = 'Gwira Paradzai Resume.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleShare = async () => {
    if (navigator.share) {
      try {
        // Try to share the file
        const response = await fetch(resume);
        const blob = await response.blob();
        const file = new File([blob], 'Gwira Paradzai Resume.pdf', { type: 'application/pdf' });
        
        if (navigator.canShare && navigator.canShare({ files: [file] })) {
          await navigator.share({
            title: 'Gwira Paradzai Resume',
            text: 'Check out my resume',
            files: [file]
          });
        } else {
          // Fallback to sharing URL
          await navigator.share({
            title: 'Gwira Paradzai Resume',
            text: 'Check out my resume',
            url: window.location.href.split('#')[0] + '#skill'
          });
        }
      } catch (err) {
        // User cancelled or error occurred, fallback to copy link
        if (err.name !== 'AbortError') {
          copyResumeLink();
        }
      }
    } else {
      copyResumeLink();
    }
  };

  const copyResumeLink = () => {
    const link = window.location.href.split('#')[0] + '#skill';
    navigator.clipboard.writeText(link).then(() => {
      alert('Resume link copied to clipboard!');
    });
  };

  const colorConfig = {
    backgroundColor: 'var(--primary)',
    borderColor: 'var(--secondary)',
    edgeColors: {
      left: 'transparent',
      top: 'transparent',
      right: 'var(--black)',
      bottom: 'var(--black)'
    },
    color: 'var(--black)'
  }

  return (
    <>
      <section id="skill" className='skillAndExperience'>
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="skill__heading-1">
                <h2 className="section__heading">Skills and <br />Experience</h2>
              </div>
              <div className="skill">
                <h3 className="skill__heading-2"><b className="tags">&lt;</b>My Skills<b className="tags">/&gt;</b></h3>
                <div className="row justify-content-center text-center">
                  {React.Children.toArray(
                      skill.map((item) => {
                        return (
                          <div key={item.key} className="col-lg-2 col-md-2 col-sm-3 col-xs-3 col-4">
                            <div className="skill__detail">
                              <div className="skill__icon">
                                <i className={item.skill}></i>
                              </div>
                            </div>
                          </div>
                        )
                      })
                    )
                  }
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-xl-5 ms-auto experience-column">
              <div className="experience">
                <h3 className='exp_heading-2'><b className="tags">&lt;</b>Experience<b className="tags">/&gt;</b></h3>
                <div className="experience__details">
                  {
                    React.Children.toArray(
                      experience.map((item, index) => {
                        return (
                          <div key={item.key} className="experience__item">
                            <div className="experience__timeline">
                              <div className="experience__timeline-dot"></div>
                              {index < experience.length - 1 && <div className="experience__timeline-line"></div>}
                            </div>
                            <div className="experience__content">
                              <div className="experience__duration">
                                <i className="fas fa-calendar-alt"></i>
                                <span>{item.duration}</span>
                              </div>
                              <div className="experience__position">
                                <h5>{item.position}</h5>
                                <div className="experience__company">
                                  <i className="fas fa-building"></i>
                                  <p>{item.company}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        )
                      })
                    )
                  }
                </div>
              </div>
              <div className="get-resume">
                <a href={resume} target="_blank" rel="noreferrer" onMouseOver={() => { setIsOver(true) }} onMouseOut={() => { setIsOver(false) }}><Button colorConfig={colorConfig} className={isOver && "active"} variant="primary" kind="elevated" size="medium" colorMode="dark" ><i className="fas fa-download"></i> Get Resume</Button></a>
              </div>
              <div className="resume-preview">
                <div className="resume-preview-toolbar">
                  <div className="resume-toolbar-right">
                    <button 
                      className="resume-toolbar-btn resume-toolbar-btn-primary" 
                      onClick={handleDownload}
                      title="Download Resume"
                      aria-label="Download Resume"
                    >
                      <i className="fas fa-download"></i>
                      <span>Download</span>
                    </button>
                    <button 
                      className="resume-toolbar-btn resume-toolbar-btn-primary" 
                      onClick={handleShare}
                      title="Share Resume"
                      aria-label="Share Resume"
                    >
                      <i className="fas fa-share-alt"></i>
                      <span>Share</span>
                    </button>
                  </div>
                </div>
                <div className="resume-preview-container">
                  <iframe 
                    src={`${resume}#toolbar=0&navpanes=0&scrollbar=0&zoom=page-width`}
                    title="Resume Preview"
                    className="resume-preview-iframe"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Skills